var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 46,
    viewBox: "0 0 83 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1213 25.1213C83.2929 23.9497 83.2929 22.0503 82.1213 20.8787L63.0294 1.7868C61.8579 0.615224 59.9584 0.615224 58.7868 1.7868C57.6152 2.95837 57.6152 4.85786 58.7868 6.02944L75.7574 23L58.7868 39.9706C57.6152 41.1421 57.6152 43.0416 58.7868 44.2132C59.9584 45.3848 61.8579 45.3848 63.0294 44.2132L82.1213 25.1213ZM0 26H80V20H0V26Z",
    fill: "#87FCF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dbe7e2bdc4843b749682653583e6d217.svg";
export { ForwardRef as ReactComponent };